import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { px2em } from 'utils/client/scaling'

import './SelectNative.scss'

const SelectInner = props => {
  const {
    meta: { initial },
    input: { onChange },
    isDisabled,
    isWhite,
    placeholder,
    options,
    withRightIndent,
    withUnderline,
    skipPlaceholder,
    skipError,
    isRounded,
  } = props

  const Placeholder = placeholder && !skipPlaceholder && (
    <span
      className="select__placeholder"
      dangerouslySetInnerHTML={{ __html: placeholder }}
    />
  )

  const iconColor = isWhite ? 'white' : 'black'
  let wrapperClassName = ''
  let controlClassNames = 'select__control select-native__control '
  let underlineClassNames = ''
  let arrowClassNames = 'select__dropdown-arrow select-native__dropdown-arrow '
  let selectNativeControlWrapper =
    'select-native__control-wrapper d-flex align-items-center '

  wrapperClassName += skipPlaceholder ? 'mt-0 ' : ''
  wrapperClassName += skipError ? 'mb-0 ' : ''
  wrapperClassName += isWhite ? 'text--white ' : ''

  controlClassNames += isDisabled ? 'select-native__control--disabled ' : ''

  underlineClassNames += withUnderline
    ? ''
    : 'select-native__underline--invisible '
  underlineClassNames += isDisabled ? 'select-native__underline--disabled ' : ''

  arrowClassNames += isDisabled
    ? 'select-native__dropdown-arrow--disabled '
    : ''
  selectNativeControlWrapper += isRounded
    ? 'select-native__control-wrapper--rounded '
    : ''

  return (
    <label className={`select__wrapper ${wrapperClassName}`}>
      {/*
       * We are using div wrapper around select, because of we can't change height of select in ie browsers,
       * but we need to have this height of component to align form-components
       */}
      <div className={selectNativeControlWrapper}>
        <select
          className={controlClassNames}
          onChange={onChange}
          defaultValue={initial}
          disabled={isDisabled}
        >
          {options.map(option => (
            <option
              key={option.value}
              value={option.value}
              dangerouslySetInnerHTML={{ __html: option.label }}
            />
          ))}
        </select>
      </div>
      {Placeholder}
      <div
        className={arrowClassNames}
        style={{ right: isRounded ? px2em(10) : `${withRightIndent}px` }}
      >
        <Icon id="arrow_down" color={iconColor} />
      </div>
      <div className={`select-native__underline ${underlineClassNames}`} />
    </label>
  )
}

SelectInner.propTypes = {
  input: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isWhite: PropTypes.bool.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  skipError: PropTypes.bool,
  skipPlaceholder: PropTypes.bool,
  withRightIndent: PropTypes.number,
  withUnderline: PropTypes.bool,
  isRounded: PropTypes.bool,
}

SelectInner.defaultProps = {}

export default SelectInner
